export enum OrderTransitPointTimeWindowType {
  ALL_TIME = 'all-time',
  FIX = 'fix',
}
